import { render } from "./ZyraDrejtorit.vue?vue&type=template&id=05add3f7&scoped=true"
import script from "./ZyraDrejtorit.vue?vue&type=script&lang=js"
export * from "./ZyraDrejtorit.vue?vue&type=script&lang=js"

import "./ZyraDrejtorit.vue?vue&type=style&index=0&id=05add3f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05add3f7"]])

export default __exports__